'use strict';

exports.__esModule = true;

var _wendysKennyLogginsAjaxAppender = require('wendys-kenny-loggins-ajax-appender');

var _wendysKennyLogginsConsoleAppender = require('wendys-kenny-loggins-console-appender');

var _wendysKennyLogginsFilteringAppender = require('wendys-kenny-loggins-filtering-appender');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var elkLogAppenderFactory = function () {
    function elkLogAppenderFactory() {
        _classCallCheck(this, elkLogAppenderFactory);
    }

    /**
     * Initialized AjaxAppender Instance
     * @param ajaxConfigurationSettings {object}
     * @returns {class}
     */
    elkLogAppenderFactory.ajaxAppender = function ajaxAppender() {
        return _wendysKennyLogginsAjaxAppender.AjaxAppender.createAjaxAppender(this.ajaxAppenderEndpointConfig.ajax);
    };

    /**
     * Initialize Custom AjaxAppender Instance with provided endpoint
     * @param ajaxConfigurationSettings {object}
     * @returns {class}
     */


    elkLogAppenderFactory.customAjaxAppender = function customAjaxAppender(ajaxConfigurationSettings) {
        var _configurationProvided = !!ajaxConfigurationSettings && Array.isArray(Object.keys(ajaxConfigurationSettings));

        if (_configurationProvided && this._isValidAjaxConfig(ajaxConfigurationSettings)) return _wendysKennyLogginsAjaxAppender.AjaxAppender.createAjaxAppender(ajaxConfigurationSettings);

        throw 'no appender configuration for ajax in current environment';
    };

    /**
     * Initialize ConsoleAppender Instance
     * @param contextConfigurationSettings {object}
     * @returns {class}
     */


    elkLogAppenderFactory.consoleAppender = function consoleAppender(contextConfigurationSettings) {
        var _configurationProvided = !!contextConfigurationSettings && contextConfigurationSettings.hasOwnProperty('context');

        if (_configurationProvided) return new _wendysKennyLogginsConsoleAppender.ConsoleAppender(contextConfigurationSettings);

        throw 'no appender configuration for console in current environment';
    };

    /**
     * Initialize FilteringAppender Instance
     * @param appenderToWrap {class}
     * @param keysToFilter {array[*]}
     * @returns {*}
     */


    elkLogAppenderFactory.filterAppender = function filterAppender(appenderToWrap, keysToFilter) {
        var _toFilter = Array.isArray(keysToFilter) ? keysToFilter : [];
        var _filter = new _wendysKennyLogginsFilteringAppender.KeysFilter(_toFilter);
        return new _wendysKennyLogginsFilteringAppender.FilteringAppender(appenderToWrap, [_filter]);
    };

    /**
     * Filter request object
     * @param filterKeys
     * @param objectToFilter
     */


    elkLogAppenderFactory.filter = function filter(filterKeys, objectToFilter) {
        if (!Array.isArray(filterKeys) || !filterKeys.length) {
            /* return objectToFilter if array AND is empty, otherwise
               assume filters array was omitted and return argument
             */
            return Array.isArray(filterKeys) ? objectToFilter : filterKeys;
        }

        var _filter = new _wendysKennyLogginsFilteringAppender.KeysFilter(filterKeys);
        return _filter.doFilter(objectToFilter);
    };

    /**
     * Validate Ajax config model is valid
     * @param model
     * @returns {boolean}
     * @private
     */


    elkLogAppenderFactory._isValidAjaxConfig = function _isValidAjaxConfig(model) {
        if (!!!model) return false;

        var propertyList = Object.keys(this.ajaxAppenderEndpointConfig.ajax);
        var _isValid = true;

        propertyList.forEach(function (property) {
            if (!model.hasOwnProperty(property)) _isValid = false;
        });

        return _isValid;
    };

    return elkLogAppenderFactory;
}();

elkLogAppenderFactory.ajaxAppenderEndpointConfig = {
    ajax: {
        timeout: 10000,
        url: 'https://pm7bkq6c85.execute-api.us-east-1.amazonaws.com/dev/log',
        queueSize: 1,
        queueInterval: 60000,
        queueType: 'persistent-session'
    }
};
exports.default = elkLogAppenderFactory;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/log.appender.factory.js
// module id = 336
// module chunks = 0